import { find, includes } from 'lodash-es';

export default {
  methods: {
    onSetAddress(type, place) {
      const addressComponents = place.address_components;
      const country = this.getAddressComponent(addressComponents, 'country');
      const state = [
        'administrative_area_level_1',
        'administrative_area_level_2',
        'administrative_area_level_3',
        'administrative_area_level_4',
        'administrative_area_level_5',
        'administrative_area_level_6',
        'administrative_area_level_7'
      ].map(type => this.getAddressComponent(addressComponents, type)).find(Boolean)

      this[type] = place.formatted_address;
      this[`${type}State`] = state?.long_name || '';
      this[`${type}Country`] = country?.short_name || '';
    },
    getAddressComponent(components, type) {
      return find(components, (c) => includes(c.types, type));
    },
    onChangeAddress(type, event) {
      this.$refs[type].setFlags({ dirty: true });

      if (!event.data && this[type]) {
        this[type] = null;
        this[`${type}State`] = null;
        this[`${type}Country`] = null;
      }
    },
    onManualAddressEntry(type, event) {
      if (event && event.target && event.target.value) {
        this.$refs[type].setFlags({ dirty: true });
        this[type] = event.target.value;
        this[`${type}State`] = null;
        this[`${type}Country`] = null;
      }
    },
  },
};
